module.exports = __webpack_public_path__ + "img/sr-canva.ce0ac76b.png";